export const Languages = ['en'];
